export var trimAfter = function trimAfter(str, threshold) {
  return str.length > threshold ? "".concat(str.substring(0, threshold), "...") : str;
};
export var pluralize = function pluralize(word, count, inclusive, pluralWord) {
  var finalPluralWord = pluralWord ? pluralWord : "".concat(word, "s");
  var finalWord = count === 1 ? word : finalPluralWord;
  return inclusive ? "".concat(count, " ").concat(finalWord) : finalWord;
};